export default __webpack_public_path__ + "static/media/1628581868(1).a9c9fab7.jpg";